"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Snap = require("snapsvg");
const map_svg_component_1 = require("./map-svg-component");
function createMap(svgId, map) {
    const snapCtx = Snap('#' + svgId);
    const mapDimensions = getSvgDimensions(svgId);
    const mapPosition = { x: 0, y: 0 };
    const canvasMap = new map_svg_component_1.MapSvgComponent(map, snapCtx, mapPosition, mapDimensions);
    canvasMap.draw();
}
exports.createMap = createMap;
function getSvgDimensions(svgElementId) {
    const svgElement = document.getElementById(svgElementId);
    const mapWidth = svgElement.width.baseVal.valueInSpecifiedUnits;
    const mapHeight = svgElement.height.baseVal.valueInSpecifiedUnits;
    return { width: mapWidth, height: mapHeight };
}
